import { render, staticRenderFns } from "./ArticleStats.vue?vue&type=template&id=4e3c8b38&scoped=true&"
import script from "./ArticleStats.vue?vue&type=script&lang=js&"
export * from "./ArticleStats.vue?vue&type=script&lang=js&"
import style0 from "./ArticleStats.vue?vue&type=style&index=0&id=4e3c8b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c8b38",
  null
  
)

export default component.exports